// 個人信息組件
export default {
  // 頁面標題
  userCenter: "用戶中心",

  // 按鈕
  edit: "修改",
  save: "保存",
  unbind: "解綁",
  scanToBinding: "掃碼綁定",

  // 表單標簽
  username: "用戶名",
  phoneNumber: "手機號",
  createTime: "創建時間",
  account: "賬號",
  email: "郵箱",
  modifiedTime: "更改時間",
  wechat: "微信",

  // 狀態文本
  notBound: "未綁定",
  bound: "已綁定",
  noPhone: "暫無號碼",

  // 表單驗證
  usernameLengthRule: "長度在 2 到20 個字符",
  phoneLengthRule: "長度在 7 到11 個字符",
  emailRequired: "請輸入郵箱地址",
  emailFormat: "請輸入正確的郵箱地址",

  // 提示消息
  unbindConfirm: "是否解除已綁定的微信用戶?",
  tip: "提示",
  yes: "是",
  no: "否",
  unbindSuccess: "解綁成功",
  unbindCancelled: "已取消解綁",
  editSuccess: "修改成功",
  saveNotEmpty: "保存不能為空",
  phoneBinding: {
    bindPhone: "綁定手機號",
    changePhone: "更換手機號",
    notBoundTip: "您的帳戶還未綁定手機號，",
    goToBind: "前往綁定",
    bindTitle: "手機號綁定",
    changeTitle: "更換手機號",
    oldPhoneLabel: "舊手機號",
    newPhoneLabel: "新手機號",
    smsCodeLabel: "簡訊驗證碼",
    cancel: "取消",
    confirm: "確認",
    nextStep: "下一步",
    bindSuccess: "手機號綁定成功",
    changeSuccess: "手機號更換成功",
  },
};
